InputWithValidation = React.createClass
  render: ->
    className = classNames @props.className, error: @props.errorMsg
    <input {...@props} className={className}/>

module.exports = InputWithValidation
